module.exports = __webpack_public_path__ + "static/media/wizualizacja-75.3d52a094.png";